import { PromptText } from "../components/PromptText";
import { InterfaceMessage } from "../components/InterfaceMessage";
import { TextHistory } from "../types/TextHistory";
import { parseCommandsAndFlags } from "./parseCommandsAndFlags";

export const parseUserInput = (input: string): TextHistory => {
  const { command, template } = parseCommandsAndFlags(input);

  const currentTime = new Date().toISOString();
  let outputText = "";
  if (command.trim().length) {
    outputText =
      template ??
      `|${command}|: command not found`;
  }
  return {
    message: [
      <PromptText command={command} />,
      <InterfaceMessage
        key={`outputText-${currentTime}`}
        currentTime={currentTime}
        template={outputText}
      />,
    ],
    time: currentTime,
    from: "user",
    inView: true,
  };
};
